import { ProductMM } from '~/entities';
import type { ProductListItem } from '~/shared/api/ke-gateway/product/models';

export function mapProductListItemToProductMM(productListItem: ProductListItem): ProductMM {
  return new ProductMM({
    id: productListItem.productId.toString(),
    title: productListItem.title,
    photo: {
      link: {
        high: productListItem.image,
        low: productListItem.image,
      },
    },
    fullPrice: productListItem.fullPrice * 100,
    sellPrice: productListItem.sellPrice * 100,
    rating: productListItem.rating,
    feedbackQuantity: productListItem.reviewsQuantity,
    ordersQuantity: productListItem.ordersQuantity,
    reviewsCount: productListItem.reviewsQuantity,
    skuGroup: productListItem.skuGroup,
    badges: productListItem.badges?.map((badge) => ({
      backgroundColor: badge.backgroundColor ?? '',
      description: badge.description,
      id: badge.id ?? '',
      link: badge.link,
      text: badge.text ?? '',
      textColor: badge.textColor ?? '',
    })),
    isAdultCategory: productListItem.isAdultCategory,
    isEco: productListItem.isEco,
    isFavorite: !!productListItem.isFavorite,
    offer: productListItem.offer,
    deliveryDate: productListItem.deliveryDate,
    inStock: true,
  });
}
